import { IntlShape } from "react-intl";

import { objectEntries, objectFromEntries, objectKeys } from "@nens/shared-utils";

import nl from "./languages/nl.json";
export * from "./translatable-texts";

export const getLocalesWithLabels = <T extends IntlShape | undefined>(intl?: T) =>
  ({
    en: {
      translations: {},
      label: intl?.formatMessage({
        id: "language.english",
        defaultMessage: "English",
      }) as T extends IntlShape ? string : undefined,
    },
    nl: {
      translations: nl,
      label: intl?.formatMessage({
        id: "language.dutch",
        defaultMessage: "Dutch",
      }) as T extends IntlShape ? string : undefined,
    },
  } as const);

const LOCALES = getLocalesWithLabels();

export const supportedLocales = objectKeys(LOCALES);
export const defaultLocale = "en" as keyof typeof LOCALES;

export const translations: Record<string, Record<string, string>> = objectFromEntries(
  objectEntries(LOCALES).map(([key, value]) => [key, value.translations])
);
